/**
 * useClientMetricSuggestions — cross-platform metric union suggestions (Story 16.4).
 * Fetches GET /api/clients/:id/metric-suggestions: for each curated concept
 * (Total Ad Spend, …), the union members on the platforms THIS client has
 * connected (≥2). The panel builds a chosen suggestion into a custom-metric
 * SUM formula (per-variable platform). Mirrors useClientCustomMetrics.
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../lib/apiClient";

export interface SuggestedMetricMember {
  platform: string;
  platformLabel: string;
  metricKey: string;
  label: string;
}

export interface SuggestedMetric {
  key: string;
  label: string;
  outputFormat: "number" | "currency" | "percentage";
  members: SuggestedMetricMember[];
}

export function useClientMetricSuggestions(clientId: string | undefined) {
  return useQuery<SuggestedMetric[]>({
    queryKey: ["client-metric-suggestions", clientId],
    queryFn: async () => {
      const res = await apiGet(`/api/clients/${clientId}/metric-suggestions`);
      if (!res.ok) return [];
      const json = (await res.json()) as {
        data: { suggestions: SuggestedMetric[] };
      };
      return json.data.suggestions;
    },
    enabled: !!clientId,
  });
}
